import { FlexBox, Icon } from '@fable/components'
import { Book } from '@fable/types'
import { isBookPreorder } from '@fable/utils'
import { BookDetailPreorderNote } from '../BookDetailPreorderNote'

import { BookDetailBuyButton } from './BookDetailBuyButton'
import { BookDetailDownloadAppCTA } from './BookDetailDownloadAppCTA'
import { css, useTheme } from '@fable/theme'

interface Props {
  book: Book
}

export const BookDetailButtonsV2 = ({ book }: Props) => {
  const { mediaQueries } = useTheme()
  const preorder = isBookPreorder(book)

  return (
    <>
      <FlexBox
        className={css`
          flex-direction: column;
          ${mediaQueries.mobileL} {
            flex-direction: row;
          }
        `}
        alignItems="center"
        gap="8px"
      >
        <BookDetailDownloadAppCTA
          className={css`
            width: 100%;
          `}
          options={{
            eventMetadata: {
              book_id: book?.id,
            },
          }}
        >
          Want to read
          <Icon
            className={css`
              margin-left: 4px;
              width: 20px;
            `}
            type="caret-down"
          />
        </BookDetailDownloadAppCTA>
        <BookDetailBuyButton book={book} outline />
      </FlexBox>
      {preorder ? (
        <BookDetailPreorderNote published_date={book?.published_date} />
      ) : null}
    </>
  )
}
